import { environment } from "../environments/environment";

declare const window: any;

export class ConfigService {
  public static apiUrl: string = this.getApiUrl();
  public static apiSignalR: string = this.getApiSignalR();

  public static getApiUrl() {
    let url = environment.api;
    return url;
  }

  public static getApiSignalR() {
    let url = environment.apiSignalR;
    return url;
  }
}